<!-- Loader starts-->
<div class="loader-wrapper" [class.loderhide]="!show">
    <div class="logo-data--collector">
        <div style="display: flex; justify-content: center">
            <img width="450" src="assets/images/logo/logo-full.png" alt="" />
        </div>
        <!-- <h4 class="text-center" style="text-transform: uppercase">
            <b>KANIS LOGISTICS CI</b>
        </h4> -->
    </div>
    <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>
<!-- Loader ends-->
